/**
 * Product Card Component
 * --------------------------------------------------------------------------------
 * @summary quickadd logic
 */
class ProductGetTheLook extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      quickAddOpen: '[js-quick-add-open]',
      quickAddForm: '[js-quick-add-form]',
      quickAddClose: '[js-quick-add-close]',
      quickAddSubmit: '[js-quick-add-submit]',
      quickAddInput: '[js-quick-add-input]',
      quickAddError: '[js-quick-add-error]',
      quickAddSingleVariant: '[js-quick-add-single]',
      quickAddCell: '[js-quick-add-cell]',
      quickAddGrid: '[js-quick-add-grid]',
      quickAddProductData: '#quickadd-product-data',
      relatedCore: '[js-related-core-colors]',
      relatedSeasonal: '[js-related-seasonal-colors]',
      relatedGroup: '[js-related-colors-group]',
      productCardTitle: '[js-productcard-title]',
      productCardImgUrl: '[js-productcard-imgurl]',
      productCardTitleUrl: '[js-productcard-titleurl]',
      productCardId: '[js-productcard-id]',
      productCardPriceContainer: '[js-productcard-price-container]',
      productCardPrice: '[js-productcard-price]',
      productCardComparePrice: '[js-productcard-compareprice]',
      productCardDiscount: '[js-productcard-discount]',
      productCardImages: '[js-productcard-images]',
      productBadge: '[js-product-badge]',
      productCardRemainingUrl: '[js-remaining-url]',
      sizeSelect: '[js-size-select]',
      atcButton: '[js-product-atc-button]',
      gtlProductData: '[js-gtl-product-data]',
      detailsButton: '[js-product-details-button]'
    };

    // Cache DOM elements
    this.cachedElements = {};
    this.cartDrawer = null;
  }

  connectedCallback(){
    this._cacheElements();
    // this._initImageSwiper();
    // this._initQuickAdd();
    this._initRelatedSeasonalColors();
    this._initAtcButton();
  }

  disconnectedCallback() {
    // Cleanup event listeners
    if (this._swiperHandlers) {
      const { wrapper, enter, leave } = this._swiperHandlers;
      wrapper.removeEventListener('mouseenter', enter);
      wrapper.removeEventListener('mouseleave', leave);
    }

    // Destroy swiper instance
    if (this._swiperInstance) {
      this._swiperInstance.destroy(true, true);
      this._swiperInstance = null;
    }
  }

  _cacheElements() {
    this.cachedElements.quickAddOpen = this.querySelector(this.selectors.quickAddOpen);
    this.cachedElements.quickAddForm = this.querySelector(this.selectors.quickAddForm);
    this.cachedElements.quickAddSingleVariant = this.querySelector(this.selectors.quickAddSingleVariant);
    this.cachedElements.sizeSelect = this.querySelector(this.selectors.sizeSelect);
    this.cachedElements.atcButton = this.querySelector(this.selectors.atcButton);
    this.cartDrawer = document.querySelector('#CartDrawer');
  }

  _initImageSwiper() {
    const swiperWrapper = this.querySelector('.product-image-carousel');
    if (!swiperWrapper || !window.Swiper) return;

    const disableMobileCarousel = this.dataset.disableMobileCarousel === 'true';
    const disableDesktopCarousel = this.dataset.disableDesktopCarousel === 'true';
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;

    const shouldInitSwiper =
      (isDesktop && !disableDesktopCarousel) || (!isDesktop && !disableMobileCarousel);
    if (!shouldInitSwiper) return;
  
    // --- 1. DEBOUNCE FOR MOUSE ---
    let hoverTimeout;
    const debounceHover = (callback, delay = 100) => {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(callback, delay);
    };
  
    // --- 2. INIT SWIPER ---
    let config = {
      slidesPerView: 1,
      resistanceRatio: 0,
      touchReleaseOnEdges: false,
      loop: false,
      // Default effect is 'slide', so we don't need to state it
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: false,
      },
    };

    if (isDesktop) {
      config = {
        ...config, // Keep the base settings
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove: false, // Disable swiping on desktop
        navigation: {
           nextEl: this.querySelector(".swiper-button-next"),
           prevEl: this.querySelector(".swiper-button-prev"),
        }
      };
    }

    const swiper = new window.Swiper(swiperWrapper, config);

    // --- 3. BUTTON LOGIC ---
    const navButtons = [
      this.querySelector(".swiper-button-next"),
      this.querySelector(".swiper-button-prev")
    ];
  
    navButtons.forEach(btn => {
      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
        });
      }
    });
  
    this._swiperInstance = swiper;
  
    // --- 4. MOUSE HANDLERS (DESKTOP) ---
    const handleMouseEnter = () => {
      debounceHover(() => {
        if (swiper.slides.length > 1) swiper.slideTo(1, 300);
      });
    };
  
    const handleMouseLeave = () => {
      debounceHover(() => {
        swiper.slideTo(0, 300);
      });
    };
  
    // --- 5. LONG PRESS HANDLERS (MOBILE) ---
    let pressTimer;
    
    const handleTouchStart = () => {
      // Start the timer when finger touches screen
      pressTimer = setTimeout(() => {
        // ACTION: Show 2nd slide (Mimic Hover)
        if (swiper.slides.length > 1) swiper.slideTo(1, 300);
        console.log("Long Press Triggered"); 
      }, 600); // 600ms wait time
    };
  
    const handleTouchEnd = () => {
      // Finger lifted
      clearTimeout(pressTimer);
      // ACTION: Return to 1st slide
      swiper.slideTo(0, 300);
    };
  
    const handleTouchMove = () => {
      // CRITICAL: If they drag/scroll/swipe, cancel the long press immediately
      clearTimeout(pressTimer);
    };

    // --- 6. ATTACH LISTENERS ---
    // Only attach mouseenter/mouseleave events on desktop (not on mobile)
    if (window.innerWidth > 768) {
      swiperWrapper.addEventListener('mouseenter', handleMouseEnter, { passive: true });
      swiperWrapper.addEventListener('mouseleave', handleMouseLeave, { passive: true });
    }

  
    // Touch (Add these)
    // swiperWrapper.addEventListener('touchstart', handleTouchStart, { passive: true });
    // swiperWrapper.addEventListener('touchend', handleTouchEnd, { passive: true });
    // swiperWrapper.addEventListener('touchmove', handleTouchMove, { passive: true });
  
    // --- 7. CLEANUP STORAGE ---
    this._swiperHandlers = {
      wrapper: swiperWrapper,
      enter: handleMouseEnter,
      leave: handleMouseLeave   // Add to cleanup
    };
  }

  _initQuickAdd() {
    const { quickAddOpen, quickAddSingleVariant } = this.cachedElements;

    if (quickAddOpen) {
      this.addEventListener('mouseleave', this._hideForm.bind(this));
      quickAddOpen.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (window.innerWidth <= 768) {
          this._dataToQuickAddDrawer();
        } else {
          this._showForm();
        }
      });
    } else if (quickAddSingleVariant) {
      quickAddSingleVariant.addEventListener('click', this._submitSingle.bind(this));
    }

    // Event delegation for quick-add-cell clicks
    this.addEventListener('click', (e) => {
      const quickAddCell = e.target.closest(this.selectors.quickAddCell);
      if (quickAddCell) {
        this._handleQuickAddCell(e, quickAddCell);
      }
    });
  }

  _initAtcButton() {
    const { atcButton, sizeSelect } = this.cachedElements;
    if (!atcButton) return;

    if (sizeSelect) {
      sizeSelect.addEventListener('change', () => {
        this._updateAtcButtonState(sizeSelect.value);
      });
    }

    atcButton.addEventListener('click', () => {
      const state = atcButton.dataset.state;
      const selectedVariantId = sizeSelect ? sizeSelect.value : null;
      const variantId = atcButton.dataset.variantId || selectedVariantId;

      if (!variantId) {
        this._setSelectSizeState();
        return;
      }

      if (state === 'select-size') {
        this._updateAtcButtonState(variantId);
      }
      
      const nextState = atcButton.dataset.state;

      if (nextState === 'notify') {
        this._openNotifyPopup(variantId);
      } else {
        this._addToCart(variantId);
      }
    });
  }

  _setSelectSizeState() {
    const atcButton = this.cachedElements.atcButton;
    if (!atcButton) return;

    atcButton.textContent = 'Select A Size';
    atcButton.dataset.state = 'select-size';
    atcButton.classList.remove('is-select-size', 'is-atc', 'is-notify');
    atcButton.classList.add('is-select-size');
  }

  _updateAtcButtonState(variantId) {
    const atcButton = this.cachedElements.atcButton;
    if (!atcButton) return;

    const stateClasses = ['is-select-size', 'is-atc', 'is-notify'];

    if (!variantId) {
      this._setSelectSizeState();
      return;
    }

    const productDataEl = this.querySelector(this.selectors.gtlProductData);
    if (!productDataEl) return;

    const productData = JSON.parse(productDataEl.textContent);
    const variant = productData.variants.find(v => String(v.id) === String(variantId));

    atcButton.classList.remove(...stateClasses);

    if (productData.prevent_atc) {
      atcButton.textContent = 'Notify Me When Available';
      atcButton.dataset.state = 'notify';
      atcButton.classList.add('is-notify');
    } else if (variant && !variant.available) {
      atcButton.textContent = 'Notify Me When Available';
      atcButton.dataset.state = 'notify';
      atcButton.classList.add('is-notify');
    } else {
      atcButton.textContent = 'Add to Cart';
      atcButton.dataset.state = 'atc';
      atcButton.classList.add('is-atc');
    }
  }

  _openNotifyPopup(variantId) {
    const productDataEl = this.querySelector(this.selectors.gtlProductData);
    if (!productDataEl) return;

    const productData = JSON.parse(productDataEl.textContent);
    const variant = productData.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return;

    const pname = this.querySelector(this.selectors.productCardTitle)?.textContent?.trim() || '';
    const optionName = variant.option1 || '';
    const prodId = String(productData.id);

    const notifyPopup = document.querySelector('.collection_notify_popup');
    const overlay = document.querySelector('.notify-overlay');
    const klaviyoForm = notifyPopup ? notifyPopup.querySelector('.form-klaviyo-bis') : null;

    if (notifyPopup) {
      notifyPopup.classList.add('active-notify');

      const nameElement = notifyPopup.querySelector('.Product_name');
      if (nameElement) {
        nameElement.textContent = optionName ? `${pname} - ${optionName}` : pname;
      }

      if (klaviyoForm) {
        klaviyoForm.setAttribute('data-variant-id', variantId);
        klaviyoForm.setAttribute('data-product-id', prodId);
      }

      if (overlay) overlay.classList.add('active-notify');
      document.body.classList.add('active-notify');
    }
  }

  _handleQuickAddCell(e, cell) {
    e.preventDefault();

    if (cell.classList.contains('out-of-stock')) {
      
      // Define the variables based on the clicked cell
      // Note: Make sure your HTML element has data-name="Product Name"
      const pname = cell.closest('product-card').querySelector('.product-card__title-link').textContent; 
      const varId = cell.getAttribute('data-variantid');
      const prodId = cell.getAttribute('data-productid');
      const optionName = cell.textContent;

      // Find the popup elements
      const notifyPopup = document.querySelector('.collection_notify_popup');
      const overlay = document.querySelector('.notify-overlay');
      const klaviyoForm = notifyPopup ? notifyPopup.querySelector('.form-klaviyo-bis') : null;

      if (notifyPopup) {
        // Add active class to popup
        notifyPopup.classList.add('active-notify');

        // Set Product Name
        const nameElement = notifyPopup.querySelector('.Product_name');
        if (nameElement) {
          if (optionName) {
            nameElement.textContent = `${pname} - ${optionName}`;
          } else {
            nameElement.textContent = pname;
          }
        }

        // Set Klaviyo Attributes
        if (klaviyoForm) {
          klaviyoForm.setAttribute('data-variant-id', varId);
          klaviyoForm.setAttribute('data-product-id', prodId);
        }

        // Handle Body and Overlay classes
        if (overlay) overlay.classList.add('active-notify');
        document.body.classList.add('active-notify');
      }

      return;
    }

    const variantId = cell.getAttribute('data-variantId');
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    this._addToCart(variantId);
  }

  _dataToQuickAddDrawer(){
    const productDataEl = this.querySelector(this.selectors.quickAddProductData);
    if (!productDataEl) return;

    const product = JSON.parse(productDataEl.textContent);
    const drawer = document.querySelector('#ProductCardQuickAdd');
    if (!drawer) return;

    const titleEl = drawer.querySelector('[js-quickadd-drawer-title]');
    const variantsEl = drawer.querySelector('[js-quickadd-drawer-variants]');

    if (titleEl) titleEl.textContent = product.title;

    if (titleEl) titleEl.setAttribute('data-product-id', product.id)

    if (variantsEl) {
      variantsEl.innerHTML = product.variants.map(variant => {
        const stockClass = product.prevent_atc ? 'out-of-stock' : variant.available ? '' : 'out-of-stock';
        return `<div class="product-variant-option ${stockClass}" data-variant-id="${variant.id}" js-quickadd-drawer-variant-option>${variant.option1}</div>`;
      }).join('');

      // Add loading spinner inside variants
      variantsEl.innerHTML += `
        <div class="quick-add-wrapper-inner" style="z-index: -1;" js-product-card-spinner>
          <loading-spinner style="--color: #333; --width: 24px; --height: 24px; --background: rgba(255,255,255);"></loading-spinner>
        </div>
      `;
    }

    drawer.open();
  }

  _showForm() {
    const form = this.cachedElements.quickAddForm;
    if (form) form.classList.add('-translate-y-full');
  }

  _hideForm() {
    const form = this.cachedElements.quickAddForm;
    if (form) form.classList.remove('-translate-y-full');
  }

  _submitForm() {
    const checkedInput = this.querySelector(`${this.selectors.quickAddInput}:checked`);
    const errorEl = this.querySelector(this.selectors.quickAddError);

    if (!checkedInput) {
      if (errorEl) {
        errorEl.classList.remove('hidden');
        errorEl.classList.add('block');
      }
      return;
    }

    if (errorEl) {
      errorEl.classList.add('hidden');
      errorEl.classList.remove('block');
    }

    this._addToCart(checkedInput.value, true);
  }

  _submitSingle(e) {
    const variantId = e.target.dataset.variantId;
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    const cart = document.querySelector('cart-drawer');
    if (cart) {
      cart.setActiveElement(document.activeElement);
    }

    this._addToCart(variantId, true);
  }

  /**
   * Common method to add items to cart
   * @param {string} variantId - The variant ID to add
   * @param {boolean} reloadNosto - Whether to reload Nosto cart
   */
  async _addToCart(variantId, reloadNosto = false) {
    if (!variantId) {
      console.error('No variant ID provided');
      return;
    }

    // Show loading spinner
    const spinnerWrapper = this.querySelector('[js-product-card-spinner]');
    const spinner = this.querySelector('loading-spinner');
    if (spinnerWrapper && spinner) {
      spinnerWrapper.style.zIndex = 1;
      spinner.setAttribute('loading', '');
    }

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      const data = await response.json();

      if (data.status) {
        this._handleErrorMessage(data.description);
        // Hide spinner on error
        if (spinnerWrapper && spinner) {
          spinnerWrapper.style.zIndex = -1;
          spinner.removeAttribute('loading');
        }
        return;
      }

      if (window.renderCart) {
        await window.renderCart();
      }

      if (reloadNosto && window.Nosto) {
        window.Nosto.reloadCart();
      }

      if (this.cartDrawer) {
        this.cartDrawer.open();
      }

      // Hide spinner on success
      if (spinnerWrapper && spinner) {
        spinnerWrapper.style.zIndex = -1;
        spinner.removeAttribute('loading');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      // Hide spinner on error
      if (spinnerWrapper && spinner) {
        spinnerWrapper.style.zIndex = -1;
        spinner.removeAttribute('loading');
      }
    }
  }

  _handleErrorMessage(message) {
    console.error('Cart error:', message);
    // Add user-facing error handling if needed
  }


  async _initRelatedSeasonalColors() {
    const containers = this.querySelectorAll(this.selectors.relatedGroup);
    if (containers.length === 0) return;

    const firstContainer = containers[0];
    const currentProductHandle = firstContainer.getAttribute("data-handle");
    const relatedColorsGroup = firstContainer.getAttribute("data-group");
    const finalColor = firstContainer.getAttribute("data-color");

    // if (!relatedColorsGroup) return;

    if (currentProductHandle && !relatedColorsGroup) {
      try {
        const colorEntry = window.color_data.find((color) => {
          if (color.name == finalColor.toLowerCase().toString()) {
            return color;
          }
        });

        if (!colorEntry) return;

        const productJSON = [
          {
            handle: currentProductHandle,
            meta_swatch: colorEntry
          },
        ];

        const { orderedList, remainingCount } = this._buildSwatchList(
          productJSON,
          currentProductHandle,
        );

        const relatedColorsMarkup = this._renderSwatches(
          orderedList,
          currentProductHandle,
          remainingCount,
        );

        containers.forEach((container) => {
          container.innerHTML = relatedColorsMarkup;
        });

        this._attachSwatchListeners();

        return;
      } catch (error) {
        console.error("Error loading related seasonal colors:", error);
      }
    } else {
      try {
        const targetURL = `/collections/all/${relatedColorsGroup}/?view=json`;
        let relatedColorsJSON = await this._getRelatedColorJSON(targetURL);

        if (relatedColorsJSON.length === 0) return;

        relatedColorsJSON = relatedColorsJSON.filter( product => product.available == true );

        const { orderedList, remainingCount } = this._buildSwatchList(
          relatedColorsJSON,
          currentProductHandle,
        );

        const relatedColorsMarkup = this._renderSwatches(
          orderedList,
          currentProductHandle,
          remainingCount,
        );

        containers.forEach((container) => {
          container.innerHTML = relatedColorsMarkup;
        });

        this._attachSwatchListeners();
      } catch (error) {
        console.error("Error loading related seasonal colors:", error);
      }
    }
  }

  _buildSwatchList(products, currentHandle) {
    const currentProduct = products.find(p => p.handle === currentHandle);
    const otherProducts = products.filter(p => p.handle !== currentHandle);

    const orderedList = currentProduct ? [currentProduct] : [];
    let maxSwatches;
    if (this.closest('#CartDrawer')) {
      maxSwatches = window.innerWidth <= 767 ? 3 : 4;
    } else {
      maxSwatches = window.innerWidth <= 767 ? 4 : 5;
    }
    const remainingSlots = maxSwatches - orderedList.length;
    const visibleOthers = otherProducts.slice(0, remainingSlots);

    orderedList.push(...visibleOthers);

    return {
      orderedList,
      remainingCount: otherProducts.length - visibleOthers.length
    };
  }

  _renderSwatches(orderedList, currentHandle, remainingCount) {
    const swatches = orderedList.map(product => {
      const swatch = this._createSwatchHTML(product);
      const isActive = product.handle === currentHandle ? 'active' : '';
      return `<div data-handle="${product.handle}" class="product-card-swatch ${isActive}" aria-label="${product.color}">${swatch}</div>`;
    }).join('');

    const remainingHTML = remainingCount > 0
      ? `<a href="/products/${currentHandle}" class="product-card-remaining" js-remaining-url>+${remainingCount}</a>`
      : '';

    return swatches + remainingHTML;
  }

  _createSwatchHTML(product) {

    if (product.meta_swatch && product.meta_swatch.color_code) {
      return `<div class="product-card-swatch-inner" style="background: ${product.meta_swatch.color_code};"></div>`;
    } else if (product.meta_swatch && product.meta_swatch.linear_gradient) {
      return `<div class="product-card-swatch-inner" style="background: ${product.meta_swatch.linear_gradient};"></div>`;
    } else if (product.meta_swatch && product.meta_swatch.image) {
      return `<div class="product-card-swatch-inner" style="background: url(${product.meta_swatch.image});"></div>`;
    } else {
      return `<div class="product-card-swatch-inner" style="background: #000;"></div>`;
    }
  }

  _attachSwatchListeners() {
    this.querySelectorAll(".product-card-swatch").forEach((swatch) => {
      // Prefetch on hover so data + first image are ready before the click
      swatch.addEventListener("mouseenter", () => {
        const handle = swatch.getAttribute("data-handle");
        if (handle) this._prefetchSwatch(handle);
      });

      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        const handle = swatch.getAttribute("data-handle");
        if (handle) {
          this._swatchClicked(handle);
        }
      });
    });
  }

  async _prefetchSwatch(handle) {
    const relatedGroup = this.querySelector(this.selectors.relatedGroup);
    if (!relatedGroup) return;

    const originalHandle = relatedGroup.getAttribute("data-handle");
    if (handle === originalHandle) return;
    if (this._productCache.has(handle)) return;

    try {
      const response = await fetch(`/products/${handle}/?view=swatch`);
      const text = await response.text();
      const parsedHTML = new DOMParser().parseFromString(text, "text/html");
      const productInfoEl = parsedHTML.querySelector("[js-product-json]");
      if (!productInfoEl) return;

      const productInfo = JSON.parse(productInfoEl.textContent);
      this._productCache.set(handle, productInfo);

      // Preload all images so they are in browser cache by click time
      if (productInfo.images) {
        productInfo.images.forEach((src) => {
          const img = new Image();
          img.src = src;
        });
      }
    } catch (_) {
      // Silent fail — prefetch is best-effort
    }
  }

  async _getRelatedColorJSON(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();
      const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
      const jsonContainer = parsedHTML.querySelector('[js-collection-json]');
      return jsonContainer ? JSON.parse(jsonContainer.textContent) : [];
    } catch (error) {
      console.error('Error fetching related colors:', error);
      return [];
    }
  }

  async _swatchClicked(handle) {
    const relatedGroup = this.querySelector(this.selectors.relatedGroup);
    if (!relatedGroup) return;

    const originalProductHandle = relatedGroup.getAttribute('data-handle');
    if (handle === originalProductHandle) return;

    // Use prefetched data if available — avoids waiting for network on click
    // if (this._productCache.has(handle)) {
    //   this._updateProductCard(this._productCache.get(handle), handle);
    //   return;
    // }

    try {
      const targetURL = `/products/${handle}/?view=swatch`;
      const response = await fetch(targetURL);
      const text = await response.text();
      const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
      const productInfoEl = parsedHTML.querySelector('[js-product-json]');
      
      if (!productInfoEl) {
        console.error('Product info not found');
        return;
      }

      const productInfo = JSON.parse(productInfoEl.textContent);
      this._updateProductCard(productInfo, handle);
    } catch (error) {
      console.error('Error loading product swatch:', error);
    }
  }

  _updateProductCard(productInfo, handle) {
    // Use requestAnimationFrame for smoother updates
    requestAnimationFrame(() => {
      // Cache elements for batch updates
      const elements = {
        title: this.querySelector(this.selectors.productCardTitle),
        imgUrl: this.querySelector(this.selectors.productCardImgUrl),
        titleUrl: this.querySelector(this.selectors.productCardTitleUrl),
        productId: this.querySelector(this.selectors.productCardId),
        priceContainer: this.querySelector(this.selectors.productCardPriceContainer),
        price: this.querySelector(this.selectors.productCardPrice),
        comparePrice: this.querySelector(
          this.selectors.productCardComparePrice,
        ),
        discount: this.querySelector(this.selectors.productCardDiscount),
        badge: this.querySelector(this.selectors.productBadge),
        images: this.querySelectorAll(
          `${this.selectors.productCardImages} img`,
        ),
        quickAddGrid: this.querySelector(this.selectors.quickAddGrid),
        productData: this.querySelector(this.selectors.quickAddProductData),
        relatedGroup: this.querySelector(this.selectors.relatedGroup),
        remainingUrl: this.querySelector(
          this.selectors.productCardRemainingUrl,
        ),
        saleMessage: this.querySelector(this.selectors.productCardSaleMessage),
        scoreBadge: this.querySelector(this.selectors.nostoScoreBadge),
        sizeSelect: this.querySelector(this.selectors.sizeSelect),
        atcButton: this.querySelector(this.selectors.atcButton),
        gtlProductData: this.querySelector(this.selectors.gtlProductData),
        detailsButton: this.querySelector(this.selectors.detailsButton)
      };

      this._performProductCardUpdate(elements, productInfo, handle);
    });
  }

  _performProductCardUpdate(elements, productInfo, handle) {

    // Update text content
    if (elements.title) elements.title.textContent = productInfo.title;
    if (elements.price) elements.price.textContent = productInfo.price;

    // Update URLs
    if (elements.imgUrl) elements.imgUrl.href = productInfo.url;
    if (elements.titleUrl) elements.titleUrl.href = productInfo.url;

    // Update ID
    if (elements.productId) elements.productId.id = productInfo.id;

    // Update handle
    if (elements.relatedGroup) {
      elements.relatedGroup.setAttribute('data-handle', productInfo.handle);
    }

    // Update compare price and discount
    const hasComparePrice = productInfo.compare_at_price && productInfo.compare_at_price !== '';
    if (elements.priceContainer) {
      if (hasComparePrice) {
        elements.priceContainer.classList.add('compare-price');
      } else {
        elements.priceContainer.classList.remove('compare-price');
      }
    }

    if (elements.comparePrice) {
      if (hasComparePrice) {
        elements.comparePrice.textContent = productInfo.compare_at_price;
        elements.comparePrice.classList.remove('hidden');
      } else {
        elements.comparePrice.classList.add('hidden');
      }
    }

    if (elements.discount) {
      if (hasComparePrice) {
        elements.discount.textContent = productInfo.price_save;
        elements.discount.classList.remove('hidden');
      } else {
        elements.discount.classList.add('hidden');
      }
    }

    // Update badge
    if (elements.badge) {
      if (productInfo.badge && productInfo.badge !== '') {
        elements.badge.textContent = productInfo.badge;
        elements.badge.classList.remove('hidden');
      } else {
        elements.badge.classList.add('hidden');
      }
    }

    // Update images
    if (elements.images && productInfo.images && productInfo.images.length > 0) {
      // Store container height to prevent layout shift
      const imageContainer = this.querySelector('.product-card__image-container');
      const containerHeight = imageContainer ? imageContainer.offsetHeight : null;
      
      // Maintain container height during update
      if (imageContainer && containerHeight) {
        imageContainer.style.minHeight = `${containerHeight}px`;
      }
      
      elements.images.forEach((img, index) => {
        if (productInfo.images[index]) {
          const imageUrl = productInfo.images[index];
          
          // Generate responsive srcset from Shopify image URL
          // Shopify URLs can be: .../image_1024x1024.jpg or .../image.jpg?width=1024
          let baseUrl = imageUrl;
          let srcset = '';
          
          // Try to extract base URL and generate srcset
          if (imageUrl.includes('_') && imageUrl.match(/_\d+x\d+\./)) {
            // Format: .../image_1024x1024.jpg
            const match = imageUrl.match(/^(.+)_\d+x\d+(\.(jpg|jpeg|png|webp|gif).*)$/i);
            if (match) {
              baseUrl = match[1] + match[2];
              const ext = match[2];
              srcset = [
                `${match[1]}_300x${ext} 300w`,
                `${match[1]}_600x${ext} 600w`,
                `${match[1]}_900x${ext} 900w`
              ].join(', ');
            }
          } else if (imageUrl.includes('?width=')) {
            // Format: .../image.jpg?width=1024
            baseUrl = imageUrl.split('?')[0];
            srcset = [
              `${baseUrl}?width=300 300w`,
              `${baseUrl}?width=600 600w`,
              `${baseUrl}?width=900 900w`
            ].join(', ');
          }
          
          // Preserve image dimensions to prevent layout shift
          const imgWidth = img.width || img.naturalWidth || 300;
          const imgHeight = img.height || img.naturalHeight || 450;
          
          // Force image reload by removing and re-adding src
          img.src = '';
          img.removeAttribute('srcset');
          img.loading = 'eager';
          img.width = imgWidth;
          img.height = imgHeight;
          
          // Use next tick to ensure DOM updates
          requestAnimationFrame(() => {
            // Set new image source
            if (srcset) {
              img.srcset = srcset;
              img.sizes = '(max-width: 767px) 100vw, 50vw';
              // Use smallest size as src fallback
              const srcUrl = srcset.split(' ')[0];
              img.src = srcUrl;
            } else {
              // Fallback to direct URL
              img.src = imageUrl;
            }
            img.alt = productInfo.title;
            
            // Remove min-height after image loads to allow natural sizing
            img.onload = () => {
              if (imageContainer) {
                imageContainer.style.minHeight = '';
              }
            };
          });
        }
      });
      
      // Update Swiper after images are set
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (this._swiperInstance) {
            this._swiperInstance.update();
            this._swiperInstance.slideTo(0, 0);
          }
          // Remove min-height constraint after a delay
          if (imageContainer) {
            setTimeout(() => {
              imageContainer.style.minHeight = '';
            }, 300);
          }
        }, 100);
      });
    }

    // Update quick add grid
    // if (elements.quickAddGrid && productInfo.variants) {
    //   elements.quickAddGrid.innerHTML = productInfo.variants.map(variant => {
    //     const stockClass = variant.available ? '' : 'out-of-stock';
    //     return `<div class="quick-add-grid-cell ${stockClass}" data-variantId="${variant.id}" js-quick-add-cell>${variant.option1}</div>`;
    //   }).join('');
    // }

    // Update product data JSON
    // if (elements.productData && productInfo.variants) {
    //   elements.productData.textContent = JSON.stringify({
    //     title: productInfo.title,
    //     id: productInfo.id,
    //     variants: productInfo.variants
    //   });
    // }

    // Update size select dropdown
    if (elements.sizeSelect && productInfo.variants) {
      const preventAtc = !!productInfo.prevent_atc;
      elements.sizeSelect.innerHTML =
        `<option value="" disabled selected>Select size</option>` +
        productInfo.variants.map(variant => {
          const label = variant.option1 + (preventAtc || !variant.available && !variant.option1.toLowerCase().includes('sold out') ? ' - Sold Out' : '');
          return `<option value="${variant.id}" ${variant.available == false ? 'disabled' : ''}>${label}</option>`;
        }).join('');

      this.cachedElements.sizeSelect = elements.sizeSelect;
    }

    // Sync [js-gtl-product-data] so _updateAtcButtonState reads the correct variants
    if (elements.gtlProductData && productInfo.variants) {
      elements.gtlProductData.textContent = JSON.stringify({
        id: productInfo.id,
        prevent_atc: !!productInfo.prevent_atc,
        variants: productInfo.variants
      });
    }

    // Toggle size select wrapper and reset ATC button after product swap
    const isOneSize = productInfo.variants && productInfo.variants.length === 1;
    const sizeSelectWrapper = this.querySelector('.product-size-select-wrapper');
    if (sizeSelectWrapper) {
      sizeSelectWrapper.classList.toggle('hidden', isOneSize);
    }

    if (elements.atcButton) {
      if (isOneSize && productInfo.variants) {
        const singleVariant = productInfo.variants[0];
        const isAvailable = !productInfo.prevent_atc && singleVariant.available;
        elements.atcButton.dataset.variantId = String(singleVariant.id);
        elements.atcButton.classList.remove('is-select-size', 'is-atc', 'is-notify');
        if (isAvailable) {
          elements.atcButton.textContent = 'Add to Cart';
          elements.atcButton.dataset.state = 'atc';
          elements.atcButton.classList.add('is-atc');
        } else {
          elements.atcButton.textContent = 'Notify Me When Available';
          elements.atcButton.dataset.state = 'notify';
          elements.atcButton.classList.add('is-notify');
        }
      } else {
        elements.atcButton.textContent = 'Add to Cart';
        elements.atcButton.dataset.state = 'atc';
        elements.atcButton.classList.remove('is-select-size', 'is-notify');
        elements.atcButton.classList.add('is-atc');
      }
    }

    // Update active swatch
    const activeSwatch = this.querySelector('.product-card-swatch.active');
    const newActiveSwatch = this.querySelector(`.product-card-swatch[data-handle="${handle}"]`);
    if (activeSwatch) activeSwatch.classList.remove('active');
    if (newActiveSwatch) newActiveSwatch.classList.add('active');

    //Update remaining url
    if (elements.remainingUrl) elements.remainingUrl.href = productInfo.url;

    //Update details button
    if (elements.detailsButton) elements.detailsButton.querySelector('a').href = productInfo.url;
  }
}

customElements.define("product-getthelook", ProductGetTheLook);